import React from "react";
import { Button, Modal, Card } from "react-bootstrap";
import TreeMenu from "react-simple-tree-menu";
import "../../../../../../node_modules/react-simple-tree-menu/dist/main.css";
import { connect } from "react-redux";
import Icon from "components/Icons/Icon";
import "./MoveSite.scss";

class RemoveEnterpriseSite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newGroupId: null,
      hasChildrenGroup: null,
    };
  }

  render() {
    const { darkMode, handleChangeRemove } = this.props

    return (
      <>
        <Button
          variant={darkMode ? 'primary' : 'light'}
          type="submit"
          className="action-button"
          id="delete-button"
          onClick={handleChangeRemove}
        >
          <Icon className="fas fa-trash-alt icons" />
          <span className="action-text">Remove</span>
        </Button>
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
          backdrop="static"
          keyboard={false}
          className="modal"
          dialogClassName="move-site-modal"
        >
          <Modal.Header closeButton>
            <div>
              <Card.Title
                id="contained-modal-title-vcenter"
                style={{ marginRight: "100px" }}
              >
                Remove selected sites from group
              </Card.Title>
              <div
                style={{
                  display: "flex",
                  flexWrap: "nowrap",
                  flexGrow: 1,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <TreeMenu
                    data={this.props.treeData}
                    onClickItem={({ key, ...props }) => {
                      // Exclude parent Ids
                      const getLastIndex = key.lastIndexOf("/");
                      const newKey = key.substring(getLastIndex + 1);

                      const hasChildrenGroup = props.hasNodes;
                      console.log(this.props);
                      this.setState({
                        newGroupId: newKey,
                        hasChildrenGroup,
                      });
                    }}
                  />
                </div>
              </div>{" "}
            </div>
          </Modal.Header>

          <Modal.Footer>
            <Button
              variant="success"
              type="submit"
              onClick={handleChangeRemove}
            >
              Remove
            </Button>

            <Button variant="primary" onClick={this.props.onHide}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    darkMode: state.app.darkMode,
  };
};
export default connect(mapStateToProps)(RemoveEnterpriseSite);
